import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Clock, BookOpen, ShieldCheck, FileText } from 'lucide-react';
export function MechanismReveal() {
  return <section className="w-full py-24 px-6 bg-night-500 relative overflow-hidden" data-id="element-71">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-night-500 via-night-400/30 to-night-500 pointer-events-none" data-id="element-72" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-73">
        <FadeIn className="text-center mb-16 space-y-4" data-id="element-74">
          <h2 className="font-serif text-3xl md:text-5xl text-night-50" data-id="element-75">
            Te presento:{' '}
            <span className="text-amber-warm" data-id="element-76">Mapa 3R + Night Scripts</span>
          </h2>
          <p className="text-xl text-night-100" data-id="element-77">
            Un reset de 14 noches para dejar de improvisar.
          </p>
        </FadeIn>

        {/* The 3R Framework */}
        <div className="grid md:grid-cols-3 gap-6 mb-20" data-id="element-78">
          {[{
          title: 'R1 — Ritmo',
          desc: 'El día que prepara la noche (ventanas, siestas, sobrecansancio).',
          icon: Clock
        }, {
          title: 'R2 — Ritual',
          desc: 'Una rutina breve (12–20 min) que apaga el cuerpo sin convertir tu noche en una producción.',
          icon: BookOpen
        }, {
          title: 'R3 — Respuesta',
          desc: 'Un protocolo para los despertares, para que no vuelvas a improvisar.',
          icon: ShieldCheck
        }].map((item, i) => <FadeIn key={i} delay={i * 0.2} className="bg-night-400 border border-night-300 p-6 rounded-xl hover:border-amber-warm/30 transition-colors" data-id="element-79">
              <div className="w-12 h-12 bg-night-300 rounded-full flex items-center justify-center mb-4 text-amber-warm" data-id="element-80">
                <item.icon className="w-6 h-6" data-id="element-81" />
              </div>
              <h3 className="font-serif text-xl text-night-50 mb-2" data-id="element-82">
                {item.title}
              </h3>
              <p className="text-night-100 text-sm leading-relaxed" data-id="element-83">
                {item.desc}
              </p>
            </FadeIn>)}
        </div>

        {/* Night Scripts Feature - The "Unique Mechanism" */}
        <FadeIn className="bg-gradient-to-br from-night-400 to-night-300 border border-night-200 rounded-2xl p-8 md:p-12 relative overflow-hidden" data-id="element-84">
          <div className="absolute top-0 right-0 w-64 h-64 bg-amber-warm/5 rounded-full blur-[80px] pointer-events-none" data-id="element-85" />

          <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-86">
            <div className="space-y-6" data-id="element-87">
              <div className="inline-flex items-center gap-2 text-amber-warm font-mono text-sm uppercase tracking-wider" data-id="element-88">
                <FileText className="w-4 h-4" data-id="element-89" />
                <span data-id="element-90">Lo que lo vuelve distinto</span>
              </div>
              <h3 className="font-serif text-3xl md:text-4xl text-night-50" data-id="element-91">
                Night Scripts (Guiones Nocturnos)
              </h3>
              <p className="text-night-100 text-lg" data-id="element-92">
                Una hoja física con escenarios reales. Si pasa X → haces Y. Sin
                debatir contigo misma. Sin culpa. Sin reinventar.
              </p>
              <ul className="space-y-3 font-mono text-sm text-night-100/80" data-id="element-93">
                <li className="flex items-center gap-2" data-id="element-94">
                  <span className="text-amber-warm" data-id="element-95">01.</span> “Primer despertar
                  temprano”
                </li>
                <li className="flex items-center gap-2" data-id="element-96">
                  <span className="text-amber-warm" data-id="element-97">02.</span> “Medianoche”
                </li>
                <li className="flex items-center gap-2" data-id="element-98">
                  <span className="text-amber-warm" data-id="element-99">03.</span> “02:00–03:30
                  (zona difícil)”
                </li>
                <li className="flex items-center gap-2" data-id="element-100">
                  <span className="text-amber-warm" data-id="element-101">04.</span> “Se duerme en
                  brazos y explota al bajarlo”
                </li>
              </ul>
            </div>

            {/* Visual representation of a script */}
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-6 rounded-lg font-mono text-xs md:text-sm text-night-50 shadow-2xl rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-102">
              <div className="flex justify-between items-center border-b border-white/10 pb-4 mb-4" data-id="element-103">
                <span className="uppercase tracking-widest text-amber-warm" data-id="element-104">
                  Night Script #3
                </span>
                <span className="text-white/40" data-id="element-105">02:00 AM</span>
              </div>
              <div className="space-y-4" data-id="element-106">
                <p className="text-white/60" data-id="element-107">SITUACIÓN:</p>
                <p data-id="element-108">El bebé despierta llorando. Ya comió a las 11pm.</p>
                <div className="h-px bg-white/10 w-full" data-id="element-109" />
                <p className="text-white/60" data-id="element-110">ACCIÓN:</p>
                <p className="text-amber-warm" data-id="element-111">
                  1. Pausa de 3 minutos (cronometrada).
                </p>
                <p data-id="element-112">2. Entrar en silencio. No encender luz.</p>
                <p data-id="element-113">3. Mano en el pecho + Shhh fuerte.</p>
                <p data-id="element-114">4. No levantar salvo que el llanto sea nivel 8/10.</p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}